module.exports = __webpack_public_path__ + "static/media/note-2.e172f365.svg";